import {
  BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer,
} from 'recharts';

const COLORS = ['#ffa851', '#00b7a8'];

export default function AttSumChart({ data = [] }) {
  return (
    <div style={{ width: '100%', height: 300 }}>
      <div style={{ textAlign: 'center' }}>Ukupan broj izostanaka</div>
      <ResponsiveContainer>
        <BarChart
          width={350} height={200} data={data}
          margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="value" fill="#1976d2" label={{ position: 'top' }}>
            {data.map((_, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
